/**
 * @internal
 */
export const _DEBUG = false

export const EMPTY_PARAMS = Object.freeze({})
export const LOADING_PANE = Symbol('LOADING_PANE')

export const DOCUMENT_PANEL_PORTAL_ELEMENT = 'documentPanelPortalElement'
